<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="inputGroupBy != 'payment_type_id'">
                        <div class="col-md-4">
                            <base-input alternative="" label="Payment Type">
                                <!-- <a-select mode="multiple" v-model="inputPaymentType" showSearch placeholder="Enter Paynent Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" allowClear>
                                    <a-select-option v-for="option in paymentTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select> -->

                                <a-select
                                    mode="multiple"
                                    v-model="inputPaymentType"
                                    showSearch
                                    placeholder="Select Payment Type"
                                    optionFilterProp="children"
                                    style="width: 100%"
                                    :filterOption="filterOption"
                                    allowClear
                                    @change="handlePaymentTypeChange"
                                >
                                    <a-select-option 
                                        v-for="option in paymentTypeOptions" 
                                        :key="option.id" 
                                        :value="option.id">
                                        {{ option.name }}
                                    </a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox v-if="inputGroupBy == 'terminal_id' || (inputGroupBy == 'user_id' && isShowBalStatus == false) || inputGroupBy == 'site_id'" class="mb-3" v-model="isShowReservation">
                        Show Reservation
                    </base-checkbox>
                    <base-checkbox v-else-if="inputGroupBy == 'user_id' && isShowBalStatus == true" class="mb-3" v-model="isShowReservation" disabled>
                        Show Reservation
                    </base-checkbox>

                    <base-checkbox v-if="inputGroupBy == 'user_id'" class="mb-3" v-model="isShowBalStatus">
                        Show Balance and Status
                    </base-checkbox>

                    <base-checkbox v-if="inputGroupBy == 'user_id'" class="mb-3" v-model="isShowWithdraw">
                        Show Withdrawal Details
                    </base-checkbox>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                worksheet="Sales Reports"
                                :name="excelFileName"
                                type="xlsx"
                                :fetch="excelData"
                                :fields="excelHeaders">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                  Generate Report in Excel
                                </button>
                            </download-excel>

                            <!-- <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                              Generate Report in PDF
                            </button> &nbsp; &nbsp; -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
          return {
            spinning: false,
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            inputGroupBy: 'terminal_id',
            groupOptions: [
              {key: 'site_id', value: 'Site'},
              {key: 'payment_type_id', value: 'Payment Type'},
              {key: 'user_id', value: 'Cashier'},
              {key: 'terminal_id', value: 'Terminal'}
            ],
            inputPaymentType: [-1],
            paymentTypeOptions: [],
            isShowReservation: false,
            isShowBalStatus: false,
            isShowWithdraw: false,
            inputSite: [],
            site_type: "ho",
            siteOptions: [],
            birSalesReports: [],
            excelFileName: `POS_Collections_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`,
            excelHeaders: {},
            reportDescription: ''
          }
        },
        watch: {
            isShowBalStatus: function() {
                if(this.isShowBalStatus == true){
                    this.isShowReservation = false;
                } else {
                    this.isShowWithdraw = false;
                }
            },
            isShowWithdraw: function() {
                if(this.isShowWithdraw == true){
                    this.isShowBalStatus = true;
                    this.isShowReservation = false;
                }
            },
            isShowReservation: function() {
                if(this.isShowReservation == true){
                    this.isShowBalStatus = false;
                    this.isShowWithdraw = false;
                }
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            var payment_types = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            component_x.paymentTypeOptions = [
                { id: -1, name: 'All' }, 
                ...payment_types
            ];
            component_x.sort(component_x.paymentTypeOptions);

            component_x.inputPaymentType = []
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            handlePaymentTypeChange(selected) {
                if (selected.includes(-1)) {
                    // If "All" is selected, replace the selection with all payment types
                    this.inputPaymentType = this.paymentTypeOptions.map(option => option.id).filter(id => id !== -1);
                }
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            async exportRequest() {
              this.spinning= true;
              let request = {};
              let errorMsg = "";

            if (this.inputPaymentType.length == 0 && this.inputGroupBy != 'payment_type_id'){
                // alert('Please select at least one payment type.')
                errorMsg = 'Please select at least one payment type.';
            } else {
                let payment_types = []
                if(this.inputGroupBy == 'payment_type_id'){
                  this.isShowReservation = false;
                  this.isShowBalStatus = false;
                  this.isShowWithdraw = false;

                  for(var p=0; p < this.paymentTypeOptions.length; p++){
                      payment_types.push(this.paymentTypeOptions[p].id)
                  }
                } else if (this.inputGroupBy == 'terminal_id' || this.inputGroupBy == 'site_id'){
                  this.isShowBalStatus = false;
                  this.isShowWithdraw = false;

                  //spread operator for array to array assigning
                  payment_types.push(...this.inputPaymentType)
                }else{
                    payment_types.push(...this.inputPaymentType)
                }

                if(this.inputDate.length == 0){
                  // this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                  errorMsg = 'Please make sure to check your current filters.';
                  this.spinning= false;
                  return { request, errorMsg };
                }

                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/pos_collections?site_id=' + this.inputSite +
                '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:ss:mm') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:ss:mm') +
                '&group=' + this.inputGroupBy + '&payment_type_id=' + payment_types + '&show_resv=' + this.isShowReservation +
                '&show_bal=' + this.isShowBalStatus + '&show_withdraw=' + this.isShowWithdraw, null)

                if(request.error) {
                  errorMsg = request.error;
                  // this.openNotificationWithIcon('error', request.error);
                }
              }
             this.spinning= false;
              return { request, errorMsg }
            },
            async excelData() {
              const { request, errorMsg } = await this.exportRequest();

              if (errorMsg.length > 0) {
                this.openNotificationWithIcon('error', errorMsg);
                  return;
              }

              const siteSpecificRequest = request;

              if (siteSpecificRequest.length < 1) {
                this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                return
              }

              let jsonData = [];
              this.excelFileName = `POS_Collections_Report_${moment().format('YYYY_MM_DD_HH_mm_ss')}`;

              if (this.inputGroupBy == 'payment_type_id') {
                // Code here
                this.excelHeaders = {
                  "Payment Type": "paymentType",
                  "Acquiring Bank": "acquiringBank",
                  "Amount": "amount",
                  "Deposit": "deposit",
                  "Withdrawal": "withdrawal",
                  "Balance": "balance",
                  "Status": "status",
                }

                let groupHeader = "";

                siteSpecificRequest.map(siteData => {
                  const reportDetails = siteData.report_details;
                  if (reportDetails) {
                    reportDetails.map(detail => {
                      let paymentTypeName = "";
                      let bankName = "";

                      if (detail.payment_type_name == 'Cash'){
                        paymentTypeName = detail.bank_name;
                        bankName = "";
                      } else if (groupHeader == ''){
                        paymentTypeName = detail.bank_name;
                        bankName = "";
                      } else if (groupHeader != detail.payment_type_name) {
                        paymentTypeName = detail.payment_type_name;
                        bankName = detail.bank_name;
                      } else {
                        paymentTypeName = "";
                        bankName = detail.bank_name;
                      }

                      groupHeader = detail.payment_type_name;

                      jsonData.push({
                        paymentType: paymentTypeName,
                        acquiringBank: bankName,
                        amount: formatNumber(parseFloat(detail.amount).toFixed(2)),
                        deposit: formatNumber(parseFloat(detail.deposit).toFixed(2)),
                        withdrawal: formatNumber(parseFloat(detail.withdrawal).toFixed(2)),
                        balance: formatNumber(parseFloat(detail.balance).toFixed(2)),
                        status: detail.balance_status,
                      })
                    })
                  }
                })
              } else {
                this.excelHeaders = {
                  "Terminal Name": "terminalName",
                  "Cashier Name": "cashierName",
                }

                this.inputPaymentType.forEach(id => {
                  let paymentTypeName = this.paymentTypeOptions.find(x => x.id === id).name

                  this.excelHeaders[`${paymentTypeName}`] = `amount${id}`
                });

                this.excelHeaders["Others"] = "others";
                this.excelHeaders["Sales Collection"] = "salesCollection";

                if (this.isShowReservation) {
                  this.excelHeaders["Downpayment"] = "downpayment";
                }

                if(this.isShowBalStatus){
                  this.excelHeaders["Collection"] = "collection";
                  this.excelHeaders["Withdrawal"] = "withdrawal";
                  this.excelHeaders["Balance"] = "balance";
                  this.excelHeaders["Status"] = "status";
                } else {
                  this.excelHeaders["Returns"] = "returns";
                  this.excelHeaders["Net Sales"] = "netSales";
                }

                if (this.isShowReservation) {
                  this.excelHeaders["Reservation Collection"] = "reservationCollection";
                  this.excelHeaders["Reservation Cancelation"] = "reservationCancelation";
                }

                // this.excelHeaders["Return VS Exchange Variance"] = "returnVsExchange";

                siteSpecificRequest.map(siteData => {
                  const reportDetails = siteData.report_details;
                  if (reportDetails) {
                    reportDetails.map(detail => {
                      // Return Vs Exchange
                      let returnVsExchange = 0
                    //   if (!this.isShowBalStatus) {
                    //     returnVsExchange = parseFloat(detail.sales_return).toFixed(2) - parseFloat(detail.sales_exchange).toFixed(2)
                    //   }

                      let detailObj = {
                        terminalName: detail.terminal_name,
                        cashierName: detail.cashier_name,
                        others: formatNumber(parseFloat(detail.others).toFixed(2)),
                        salesCollection: formatNumber(parseFloat(detail.sales_col).toFixed(2)),
                        // returnVsExchange: formatNumber(parseFloat(returnVsExchange).toFixed(2)),
                      }

                      if(this.isShowBalStatus){
                        detailObj = {
                          ...detailObj,
                          collection: formatNumber(parseFloat(detail.downpayment).toFixed(2)),
                          withdrawal: formatNumber(parseFloat(detail.withdrawal).toFixed(2)),
                          balance: formatNumber(parseFloat(detail.balance).toFixed(2)),
                          status: detail.status
                        }
                      } else {
                        // Net Sales
                        const netSales = parseFloat(detail.sales_col).toFixed(2) - parseFloat(detail.sales_return).toFixed(2);

                        detailObj = {
                          ...detailObj,
                          returns: formatNumber(parseFloat(detail.sales_return).toFixed(2)),
                          netSales: formatNumber(parseFloat(netSales).toFixed(2)),
                        }
                      }

                      this.inputPaymentType.map(id => {
                        detailObj[`amount${id}`] = formatNumber(parseFloat(detail[`amount${id}`]).toFixed(2));
                      });

                      if (this.isShowReservation) {
                        detailObj = {
                          ...detailObj,
                          downpayment: formatNumber(parseFloat(detail.downpayment).toFixed(2)),
                          reservationCollection: formatNumber(parseFloat(detail.resv_collections).toFixed(2)),
                          reservationCancelation: formatNumber(parseFloat(detail.resv_cancellations).toFixed(2))
                        }
                      }

                      jsonData.push(detailObj)
                    })
                  }
                })
              }

                const formattedDateRange = `For the Period of ${this.inputDate[0].format('MMMM DD, YYYY hh:mm A')} to ${this.inputDate[1].format('MMMM DD, YYYY hh:mm A')}`;

                jsonData.unshift({
                    paymentType: formattedDateRange,
                    acquiringBank: "",
                    amount: "",
                    deposit: "",
                    withdrawal: "",
                    balance: "",
                    status: "",
                });

                jsonData.push({ 
                    paymentType: "", 
                    acquiringBank: "", 
                    amount: "", 
                    deposit: "", 
                    withdrawal: "", 
                    balance: "", 
                    status: "" 
                });

                const totalAmount = jsonData.reduce((sum, item) => {
                const amount = parseFloat((item.amount || "0").replace(/,/g, '') || 0);
                    // console.log(`Item Amount: ${item.amount}, Parsed Amount: ${amount}`);
                    return sum + amount;
                }, 0);

                // console.log("Total Amount:", totalAmount);

                jsonData.push({
                    paymentType: "Total",
                    acquiringBank: "",
                    amount: formatNumber(totalAmount.toFixed(2)),
                    deposit: "",
                    withdrawal: "",
                    balance: "",
                    status: "",
                });

              return jsonData;
            },
            generateReport: async function () {
                this.spinning= true;
                const { request, errorMsg } = await this.exportRequest();

                if (errorMsg.length > 0) {
                  this.openNotificationWithIcon('error', errorMsg);
                  return;
                }

                var siteSpecific = request;

                if (siteSpecific.length < 1) {
                  this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                  this.spinning= false;
                  return;
                }

                let doc = []
                if(this.inputGroupBy == 'payment_type_id'){
                    doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal'});

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [
                        [
                            {content: 'Payment Type', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Acquiring Bank', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Amount', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Deposit', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Withdrawal', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Balance', styles: {halign: 'center', valign: 'center'}},
                            {content: 'Status', styles: {halign: 'center', valign: 'center'}}
                        ]
                    ];

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        if(this.birSalesReports.length > 0){
                            let reportData = [];

                            let grand_deposit = 0
                            let grand_withdrawal = 0
                            let grand_amount = 0
                            let grand_balance = 0

                            let sub_deposit = 0
                            let sub_withdrawal = 0
                            let sub_amount = 0
                            let sub_balance = 0

                            let group_header = ""

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let detail = []
                                if(reportLine.payment_type_name == 'Cash'){
                                    detail = [
                                        reportLine.bank_name,
                                        '',
                                        this.convertToCurrency(Number(reportLine.amount)),
                                        this.convertToCurrency(Number(reportLine.deposit)),
                                        this.convertToCurrency(Number(reportLine.withdrawal)),
                                        this.convertToCurrency(Number(reportLine.balance)),
                                        reportLine.balance_status
                                    ]
                                } else {
                                    if(group_header == ''){
                                        detail = [
                                            reportLine.payment_type_name,
                                            reportLine.bank_name,
                                            this.convertToCurrency(Number(reportLine.amount)),
                                            this.convertToCurrency(Number(reportLine.deposit)),
                                            this.convertToCurrency(Number(reportLine.withdrawal)),
                                            this.convertToCurrency(Number(reportLine.balance)),
                                            reportLine.balance_status
                                        ]
                                    } else {
                                        if(group_header != reportLine.payment_type_name){
                                            detail = [
                                                reportLine.payment_type_name,
                                                reportLine.bank_name,
                                                this.convertToCurrency(Number(reportLine.amount)),
                                                this.convertToCurrency(Number(reportLine.deposit)),
                                                this.convertToCurrency(Number(reportLine.withdrawal)),
                                                this.convertToCurrency(Number(reportLine.balance)),
                                                reportLine.balance_status
                                            ]
                                        } else {
                                            detail = [
                                                '',
                                                reportLine.bank_name,
                                                this.convertToCurrency(Number(reportLine.amount)),
                                                this.convertToCurrency(Number(reportLine.deposit)),
                                                this.convertToCurrency(Number(reportLine.withdrawal)),
                                                this.convertToCurrency(Number(reportLine.balance)),
                                                reportLine.balance_status
                                            ]
                                        }
                                    }
                                }

                                reportData.push(Object.assign({}, detail))

                                group_header = reportLine.payment_type_name

                                grand_deposit += Number(reportLine.deposit)
                                grand_withdrawal += Number(reportLine.withdrawal)
                                grand_amount += Number(reportLine.amount)
                                grand_balance += Number(reportLine.balance)

                                if(reportLine.payment_type_name == 'Debit Card' || reportLine.payment_type_name == 'Credit Card' || reportLine.payment_type_name == 'Cash'){
                                    sub_deposit += Number(reportLine.deposit)
                                    sub_withdrawal += Number(reportLine.withdrawal)
                                    sub_amount += Number(reportLine.amount)
                                    sub_balance += Number(reportLine.balance)
                                }

                                if(i == this.birSalesReports.length - 1){
                                    if(reportLine.payment_type_name == 'Debit Card' || reportLine.payment_type_name == 'Credit Card' || reportLine.payment_type_name == 'Cash'){
                                        let sub_detail = [
                                            '', 'Subtotal :', this.convertToCurrency(sub_amount),
                                            this.convertToCurrency(sub_deposit),
                                            this.convertToCurrency(sub_withdrawal),
                                            this.convertToCurrency(sub_balance)
                                        ];

                                        reportData.push(Object.assign({}, sub_detail))
                                    }

                                    let grand_detail = [
                                        '', 'Grand Total :', this.convertToCurrency(grand_amount),
                                        this.convertToCurrency(grand_deposit),
                                        this.convertToCurrency(grand_withdrawal),
                                        this.convertToCurrency(grand_balance)
                                    ];
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    if(reportLine.payment_type_name == 'Debit Card' || reportLine.payment_type_name == 'Credit Card' || reportLine.payment_type_name == 'Cash'){
                                        let next_grouper = this.birSalesReports[i+1].payment_type_name
                                        let grouper = this.birSalesReports[i].payment_type_name

                                        if(grouper != next_grouper){
                                            let sub_detail = [
                                            '', 'Subtotal :', this.convertToCurrency(sub_amount),
                                                this.convertToCurrency(sub_deposit),
                                                this.convertToCurrency(sub_withdrawal),
                                                this.convertToCurrency(sub_balance)
                                            ];

                                            reportData.push(Object.assign({}, sub_detail))

                                            sub_deposit = 0
                                            sub_withdrawal = 0
                                            sub_amount = 0
                                            sub_balance = 0
                                        }
                                    }
                                }
                            }

                            doc.setFontSize(14);
                            doc.setFontType("bold");

                            doc.text(15,20,"POS Collections Report by Payment Type")
                            doc.setFontType("normal");
                            doc.setFontSize(10);

                            doc.text(340,20,siteSpecific[x].report_details[0].site_name, "right")
                            doc.text(15,25,"From " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                            doc.text(15,30,"(Payment Types)")

                            doc.autoTable({
                                startY: 35,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 9,
                                    halign: 'right'
                                },
                                columnStyles: {
                                    0: {cellWidth: 45},
                                    1: {cellWidth: 45},
                                    2: {cellWidth: 45},
                                    3: {cellWidth: 45},
                                    4: {cellWidth: 45},
                                    5: {cellWidth: 45},
                                    6: {cellWidth: 45},
                                    7: {cellWidth: 45}
                                },
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[1] == 'Grand Total :' || data.row.raw[1] == 'Subtotal :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });

                            doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                            doc.text(340,200,"POS Collections Report by Payment Type", "right")

                            doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY h:mm:ssA"))
                            doc.text(340,205,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        }
                    }
                } else {
                    var payment_count = this.inputPaymentType.length;

                    if(this.isShowReservation == true){
                        payment_count += 3
                    }

                    let remaining_width = 0
                    if(payment_count <= 5){
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal'});
                        remaining_width = (5 - payment_count) * 30
                    } else if(payment_count <= 7) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3'});
                        remaining_width = (7 - payment_count) * 30
                    } else if(payment_count <= 10) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3'});
                        remaining_width = (10 - payment_count) * 30
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                        remaining_width = (18 - payment_count) * 30
                    }

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = []
                    let colStyle = {
                        0: {cellWidth: 30}
                    }

                    headers.push([]);
                    headers[0].push({content: ''});

                    let num = 1
                    this.inputPaymentType.forEach(element => {
                        let payment_type = this.paymentTypeOptions.find(x => x.id === element).name
                        headers[0].push({content: payment_type, styles: {halign: 'center'}});

                        Object.assign(colStyle, {
                            [num]: {cellWidth: 30}
                        });

                        num += 1;
                    });
                    if(remaining_width > 0){
                        Object.assign(colStyle, {
                            [num]: {cellWidth: remaining_width}
                        });
                        num += 1
                    }

                    Object.assign(colStyle, {
                        [num]: {cellWidth: 30},
                        [num+1]: {cellWidth: 30},
                    });
                    num += 2

                    if(this.isShowReservation == true){
                        Object.assign(colStyle, {
                            [num]: {cellWidth: 30}
                        });
                        num += 1
                    }

                    Object.assign(colStyle, {
                        [num]: {cellWidth: 25},
                        [num+1]: {cellWidth: 30}
                    });
                    num += 2

                    if(this.isShowReservation == true){
                        Object.assign(colStyle, {
                            [num]: {cellWidth: 30},
                            [num+1]: {cellWidth: 30}
                        });
                        num += 2
                    }

                    Object.assign(colStyle, {
                        [num]: {cellWidth: 30}
                    });
                    if(remaining_width > 0){
                        headers[0].push('')
                    }

                    headers[0].push({content: "Others", styles: {halign: 'center'}})
                    if(this.isShowBalStatus == false){
                        headers[0].push({content: "Sales\nCollection", styles: {halign: 'center'}})
                    }

                    if(this.isShowReservation == true){
                        headers[0].push({content: "Downpayment", styles: {halign: 'center'}})
                    }

                    if(this.isShowBalStatus == true){
                        headers[0].push({content: "Collection", styles: {halign: 'center'}})
                        headers[0].push({content: "Withdrawal", styles: {halign: 'center'}})
                        headers[0].push({content: "Balance", styles: {halign: 'center'}})
                        headers[0].push({content: "Status", styles: {halign: 'center'}})
                    } else {
                        headers[0].push({content: "Returns", styles: {halign: 'center'}})
                        headers[0].push({content: "Net Sales", styles: {halign: 'center'}})
                    }

                    if(this.isShowReservation == true){
                        headers[0].push({content: "Reservation\nCollection", styles: {halign: 'center'}})
                        headers[0].push({content: "Reservation\nCancellation", styles: {halign: 'center'}})
                    }

                    if(this.isShowBalStatus == false){
                        headers[0].push({content: "Return vs\nExchange\nVariance", styles: {halign: 'center'}})
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let grouper = '';

                            let subtotal = {
                                others: 0,
                                sales_col: 0,
                                sales_return: 0,
                                net_sales: 0,
                                return_vs_exchange: 0
                            }

                            let grandtotal = {
                                others: 0,
                                sales_col: 0,
                                sales_return: 0,
                                net_sales: 0,
                                return_vs_exchange: 0
                            }

                            if(this.isShowReservation == true){
                                Object.assign(subtotal, {
                                    downpayment: 0,
                                    resv_collections: 0,
                                    resv_cancellations: 0
                                })

                                Object.assign(grandtotal, {
                                    downpayment: 0,
                                    resv_collections: 0,
                                    resv_cancellations: 0
                                })
                            }

                            if(this.isShowBalStatus == true){
                                Object.assign(subtotal, {
                                    withdrawal: 0,
                                    balance: 0
                                })

                                Object.assign(grandtotal, {
                                    withdrawal: 0,
                                    balance: 0
                                })
                            }

                            this.inputPaymentType.forEach(element => {
                                Object.assign(subtotal, {
                                    [`amount${element}`]: 0
                                })

                                Object.assign(grandtotal, {
                                    [`amount${element}`]: 0
                                })
                            });

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                if(this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        let detail1 = ['Cashier :', {content: reportLine.cashier_name, styles: {halign: 'left'}}];
                                        reportData.push(Object.assign({}, detail1))
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            let detail1 = ['Cashier :', {content: reportLine.cashier_name, styles: {halign: 'left'}}];
                                            reportData.push(Object.assign({}, detail1))
                                        }
                                    }

                                    let detail2 = ['Terminal :', {content: reportLine.terminal_name, styles: {halign: 'left'}}];
                                    reportData.push(Object.assign({}, detail2))

                                    grouper = reportLine.user_id
                                } else if(this.inputGroupBy == 'terminal_id'){
                                    if(grouper == ''){
                                        let detail1 = ['Terminal :', {content: reportLine.terminal_name, styles: {halign: 'left'}}];
                                        reportData.push(Object.assign({}, detail1))
                                    } else {
                                        if(grouper != reportLine.terminal_id){
                                            let detail1 = ['Terminal :', {content: reportLine.terminal_name, styles: {halign: 'left'}}];
                                            reportData.push(Object.assign({}, detail1))
                                        }
                                    }

                                    let detail2 = ['Cashier :', {content: reportLine.cashier_name, styles: {halign: 'left'}}];
                                    reportData.push(Object.assign({}, detail2))

                                    grouper = reportLine.terminal_id
                                } else if(this.inputGroupBy == 'site_id'){
                                    let detail1 = ['Site :', {content: reportLine.site_name, styles: {halign: 'left'}}];
                                    reportData.push(Object.assign({}, detail1))

                                    grouper = reportLine.site_id
                                }

                                //details
                                let detail3 = []
                                if(this.inputGroupBy == 'terminal_id' || this.inputGroupBy == 'user_id'){
                                    detail3.push('');
                                } else if(this.inputGroupBy == 'site_id'){
                                    detail3.push('Total :');
                                }

                                this.inputPaymentType.forEach(element => {
                                    let payment_detail = reportLine[`amount${element}`];
                                    detail3.push(this.convertToCurrency(Number(payment_detail)));
                                });
                                if(remaining_width > 0){
                                    detail3.push('')
                                }
                                detail3.push(this.convertToCurrency(Number(reportLine.others)))
                                detail3.push(this.convertToCurrency(Number(reportLine.sales_col)))
                                if(this.isShowReservation == true){
                                    detail3.push(this.convertToCurrency(Number(reportLine.downpayment)))
                                }

                                let net_sales = 0
                                if(this.isShowBalStatus == true){
                                    detail3.push(this.convertToCurrency(Number(reportLine.withdrawal)))
                                    detail3.push(this.convertToCurrency(Number(reportLine.balance)))
                                    detail3.push(reportLine.balance_status);
                                } else {
                                    detail3.push(this.convertToCurrency(Number(reportLine.sales_return)))
                                    net_sales = Number(reportLine.sales_col) - Number(reportLine.sales_return);
                                    detail3.push(this.convertToCurrency(net_sales));
                                }

                                if(this.isShowReservation == true){
                                    detail3.push(this.convertToCurrency(Number(reportLine.resv_collections)))
                                    detail3.push(this.convertToCurrency(Number(reportLine.resv_cancellations)))
                                }

                                let return_vs_exchange = 0
                                if(this.isShowBalStatus == false){
                                    return_vs_exchange = Number(reportLine.sales_return) - Number(reportLine.sales_exchange)
                                    detail3.push(this.convertToCurrency(return_vs_exchange));
                                }
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(Object.assign({}, detail3));

                                //subtotal
                                subtotal['others'] += Number(reportLine.others);
                                subtotal['sales_col'] += Number(reportLine.sales_col);
                                subtotal['sales_return'] += Number(reportLine.sales_return);
                                subtotal['net_sales'] += net_sales;
                                subtotal['return_vs_exchange'] += return_vs_exchange;

                                grandtotal['others'] += Number(reportLine.others);
                                grandtotal['sales_col'] += Number(reportLine.sales_col);
                                grandtotal['sales_return'] += Number(reportLine.sales_return);
                                grandtotal['net_sales'] += net_sales;
                                grandtotal['return_vs_exchange'] += return_vs_exchange;

                                if(this.isShowReservation == true){
                                    subtotal['downpayment'] += Number(reportLine.downpayment);
                                    subtotal['resv_collections'] += Number(reportLine.resv_collections);
                                    subtotal['resv_cancellations'] += Number(reportLine.resv_cancellations);

                                    grandtotal['downpayment'] += Number(reportLine.downpayment);
                                    grandtotal['resv_collections'] += Number(reportLine.resv_collections);
                                    grandtotal['resv_cancellations'] += Number(reportLine.resv_cancellations);
                                }

                                if(this.isShowBalStatus == true){
                                    subtotal['withdrawal'] += Number(reportLine.withdrawal);
                                    subtotal['balance'] += Number(reportLine.balance);

                                    grandtotal['withdrawal'] += Number(reportLine.withdrawal);
                                    grandtotal['balance'] += Number(reportLine.balance);
                                }

                                this.inputPaymentType.forEach(element => {
                                    subtotal[`amount${element}`] += Number(reportLine[`amount${element}`]);
                                    grandtotal[`amount${element}`] += Number(reportLine[`amount${element}`]);
                                });

                                if(i == this.birSalesReports.length - 1){
                                    let sub_detail = []
                                    if(this.inputGroupBy == 'terminal_id'){
                                        sub_detail = ['Terminal Total :']
                                    } else {
                                        sub_detail = ['Total :']
                                    }

                                    let grand_detail = ['Grand Total :']

                                    this.inputPaymentType.forEach(element => {
                                        let subTotalTmp = subtotal[`amount${element}`];
                                        sub_detail.push(this.convertToCurrency(subTotalTmp))

                                        let grandTotalTmp = grandtotal[`amount${element}`];
                                        grand_detail.push(this.convertToCurrency(grandTotalTmp))
                                    });
                                    if(remaining_width > 0){
                                        sub_detail.push('')
                                    }
                                    sub_detail.push(this.convertToCurrency(subtotal['others']))
                                    sub_detail.push(this.convertToCurrency(subtotal['sales_col']))
                                    if(this.isShowReservation == true){
                                        sub_detail.push(this.convertToCurrency(subtotal['downpayment']))
                                    }

                                    if(this.isShowBalStatus == true){
                                        sub_detail.push(this.convertToCurrency(subtotal['withdrawal']))
                                        sub_detail.push(this.convertToCurrency(subtotal['balance']))
                                        sub_detail.push('')
                                    } else {
                                        sub_detail.push(this.convertToCurrency(subtotal['sales_return']))
                                        sub_detail.push(this.convertToCurrency(subtotal['net_sales']))
                                    }

                                    if(this.isShowReservation == true){
                                        sub_detail.push(this.convertToCurrency(subtotal['resv_collections']))
                                        sub_detail.push(this.convertToCurrency(subtotal['resv_cancellations']))
                                    }

                                    if(this.isShowBalStatus == false){
                                        sub_detail.push(this.convertToCurrency(subtotal['return_vs_exchange']))
                                    }

                                    if(this.inputGroupBy == 'terminal_id' || this.inputGroupBy == 'user_id'){
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                    }

                                    this.inputPaymentType.forEach(element => {
                                        subtotal[`amount${element}`] = 0
                                    });
                                    if(remaining_width > 0){
                                        grand_detail.push('')
                                    }
                                    grand_detail.push(this.convertToCurrency(grandtotal['others']))
                                    grand_detail.push(this.convertToCurrency(grandtotal['sales_col']))
                                    if(this.isShowReservation == true){
                                        grand_detail.push(this.convertToCurrency(grandtotal['downpayment']))
                                    }

                                    if(this.isShowBalStatus == true){
                                        grand_detail.push(this.convertToCurrency(grandtotal['withdrawal']))
                                        grand_detail.push(this.convertToCurrency(grandtotal['balance']))
                                        grand_detail.push('')
                                    } else {
                                        grand_detail.push(this.convertToCurrency(grandtotal['sales_return']))
                                        grand_detail.push(this.convertToCurrency(grandtotal['net_sales']))
                                    }

                                    if(this.isShowReservation == true){
                                        grand_detail.push(this.convertToCurrency(grandtotal['resv_collections']))
                                        grand_detail.push(this.convertToCurrency(grandtotal['resv_cancellations']))
                                    }

                                    if(this.isShowBalStatus == false){
                                        grand_detail.push(this.convertToCurrency(grandtotal['return_vs_exchange']))
                                    }
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    let next_grouper = ""
                                    if(this.inputGroupBy == 'user_id'){
                                        next_grouper = this.birSalesReports[i+1].user_id
                                    } else if(this.inputGroupBy == 'terminal_id'){
                                        next_grouper = this.birSalesReports[i+1].terminal_id
                                    }

                                    if(grouper != next_grouper){
                                        let sub_detail = []
                                        if(this.inputGroupBy == 'terminal_id'){
                                            sub_detail = ['Terminal Total :']
                                        } else {
                                            sub_detail = ['Total :']
                                        }

                                        this.inputPaymentType.forEach(element => {
                                            let subTotalTmp = subtotal[`amount${element}`];
                                            sub_detail.push(this.convertToCurrency(subTotalTmp))
                                        });
                                        if(remaining_width > 0){
                                            sub_detail.push('')
                                        }
                                        sub_detail.push(this.convertToCurrency(subtotal['others']))
                                        sub_detail.push(this.convertToCurrency(subtotal['sales_col']))
                                        if(this.isShowReservation == true){
                                            sub_detail.push(this.convertToCurrency(subtotal['downpayment']))
                                        }

                                        if(this.isShowBalStatus == true){
                                            sub_detail.push(this.convertToCurrency(subtotal['withdrawal']))
                                            sub_detail.push(this.convertToCurrency(subtotal['balance']))
                                            sub_detail.push('')
                                        } else {
                                            sub_detail.push(this.convertToCurrency(subtotal['sales_return']))
                                            sub_detail.push(this.convertToCurrency(subtotal['net_sales']))
                                        }

                                        if(this.isShowReservation == true){
                                            sub_detail.push(this.convertToCurrency(subtotal['resv_collections']))
                                            sub_detail.push(this.convertToCurrency(subtotal['resv_cancellations']))
                                        }

                                        if(this.isShowBalStatus == false){
                                            sub_detail.push(this.convertToCurrency(subtotal['return_vs_exchange']))
                                        }

                                        if(this.inputGroupBy == 'terminal_id' || this.inputGroupBy == 'user_id'){
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))
                                        }

                                        this.inputPaymentType.forEach(element => {
                                            subtotal[`amount${element}`] = 0
                                        });

                                        subtotal['others'] = 0
                                        subtotal['sales_col'] = 0
                                        subtotal['sales_return'] = 0
                                        subtotal['net_sales'] = 0
                                        subtotal['return_vs_exchange'] = 0

                                        if(this.isShowReservation == true){
                                            subtotal['downpayment'] = 0
                                            subtotal['resv_collections'] = 0
                                            subtotal['resv_cancellations'] = 0
                                        }

                                        if(this.isShowBalStatus == true){
                                            subtotal['withdrawal'] = 0
                                            subtotal['balance'] = 0
                                        }
                                    }
                                }
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let group_text = ""
                        if(this.inputGroupBy == 'terminal_id'){
                            group_text = ' by Terminal'
                        } else if(this.inputGroupBy == 'user_id'){
                            group_text = ' by Cashier'
                        } else if(this.inputGroupBy == 'site_id'){
                            group_text = ' by Site'
                        }

                        let design_x = 340
                        let design_y = 200
                        if(payment_count <= 5) {
                            //follow default
                        }
                        else if(payment_count <= 7) {
                            design_x = 400
                            design_y = 280
                        } else if(payment_count <= 10) {
                            design_x = 490
                            design_y = 330
                        } else {
                            design_x = 580
                            design_y = 400
                        }

                        doc.text(15,20,"POS Collections Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        doc.text(design_x,20,siteSpecific[x].report_details[0].site_name, "right")
                        doc.text(15,25,"From " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        let header_text = ''
                        if(this.inputGroupBy == 'user_id'){
                            header_text = '(All Cashiers)'
                        } else if (this.inputGroupBy == 'terminal_id'){
                            header_text = '(All Terminals)'
                        } else if (this.inputGroupBy == 'site_id'){
                            header_text = '(Sites)'
                        }
                        doc.text(15,30,header_text)

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 9,
                                halign: 'right'
                            },
                            columnStyles: colStyle,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[1] == 'Total :' && data.row.raw[1] == 'Terminal Total :' && data.row.raw[1] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        doc.text(15,design_y,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(design_x,design_y,"POS Collections Report" + group_text, "right")

                        doc.text(15,design_y+5,"Print Date: " + moment().format("MM/DD/YYYY h:mm:ssA"))
                        doc.text(design_x,design_y+5,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                    }
                }
                this.spinning= false;
                //doc.save(`POS_Collections_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                window.open(URL.createObjectURL(doc.output("blob")))
            }
        }
    };
</script>

<style></style>
